import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { avisar } from '@xiltrion/ui/sonner';
import { API_BASE } from '@/api/client';

/** Campana en tiempo real (SSE): un aviso nuevo refresca la lista (y «Mi día», que cuelga de `notifications`) y muestra un toast. */
export function useNotificationsStream(enabled: boolean) {
  const qc = useQueryClient();
  useEffect(() => {
    if (!enabled) return;
    const es = new EventSource(`${API_BASE}/me/notifications/stream`, { withCredentials: true });
    es.addEventListener('notification', (e) => {
      const d = JSON.parse((e as MessageEvent).data) as { data: { title?: string } };
      void qc.invalidateQueries({ queryKey: ['notifications'] });
      void qc.invalidateQueries({ queryKey: ['me'] });
      if (d.data.title) avisar(d.data.title);
    });
    // Una app publicó lo que espera a la persona: refresca «Mi día» sin aviso.
    es.addEventListener('pending', () => void qc.invalidateQueries({ queryKey: ['notifications', 'day'] }));
    return () => es.close();
  }, [enabled, qc]);
}
